import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useInvitationRemoveManyMutation } from "@/v2-backoffice-client/invitation/remove/many/invitation.remove.many.mutation"

export type InvitationRemoveManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  invitationIds: number[]
  onCompleted?(): void
}

function InvitationRemoveManyButton(props: InvitationRemoveManyButtonProps) {
  const { invitationIds, confirmContent, onCompleted, ...confirmButtonProps } =
    props
  const invitationCount = invitationIds.length

  const [removeManyInvitations, { loading, error }] =
    useInvitationRemoveManyMutation({
      onCompleted,
    })

  errorToast(error, {
    title: `Failed to remove ${invitationCount} invitation(s)`,
  })

  return (
    <ConfirmButton
      id="invitation-remove-many-button"
      variant="destructive"
      size="tiny"
      iconSrc="trash"
      content="Remove invitations"
      confirmContent={
        confirmContent ??
        `Are you sure you want to remove ${invitationCount} invitation(s)?`
      }
      isLoading={loading}
      onConfirm={() => {
        removeManyInvitations({ variables: { ids: invitationIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default InvitationRemoveManyButton
